var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2276_105)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#424246"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2276_105",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2276_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0251 -5.37085V10.3066",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.703 -5.37085V10.3066",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.074 -5.37085V10.3066",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1943 -2.31694L17.2776 7.16423V-3.62891",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.519 -2.60723L27.4358 6.87395V-3.91919",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8303 52.4032V36.7258",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.153 52.4032V36.7258",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7819 52.4032V36.7258",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8092 49.5459L27.726 40.0647V50.8579",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1938 49.6909L17.2771 40.2097V51.0029",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.45898 23.9192H9.21844",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.45898 26.2417H9.21844",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.45898 20.8708H9.21844",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.76811 33.8254L5.71306 28.7422H-5.08008",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.752 13.7905L6.72917 18.8737H-4.06396",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3148 23.1138H35.6375",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3148 20.791H35.6375",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3148 26.1619H35.6375",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0948 13.21L38.6136 18.2933H49.4067",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6753 33.6802L39.1942 28.5969H49.9873",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28613 44.2272L13.3718 33.1416",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92871 45.8693L15.0144 34.7837",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.130371 42.0717L11.216 30.9861",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7797 49.3469L14.8896 39.0483L7.25769 46.6802",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.28174 34.4299L7.01684 31.3201L-0.615057 38.952",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5699 2.80493L31.4843 13.8906",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9278 1.16284L29.8422 12.2485",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7256 4.96069L33.64 16.0463",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4151 -1.97559L30.3053 8.32299L37.9372 0.691096",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0415 12.3607L37.743 15.4705L45.3749 7.83862",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1381 43.6576L32.0525 32.572",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7807 42.0155L33.6951 30.9299",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9825 45.8134L29.8969 34.7278",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3311 34.4302L38.0325 31.3203L45.6644 38.9522",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5587 49.2019L30.4489 38.9033L38.0808 46.5352",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71631 3.37476L12.8019 14.4604",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0737305 5.01709L11.1593 16.1027",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87207 1.21899L14.9577 12.3047",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.55615 13.0865L7.74244 16.1963L0.110535 8.56445",
    stroke: "white",
    strokeWidth: 0.789865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6347 -1.54004L14.7445 8.75855L7.11267 1.12665",
    stroke: "white",
    strokeWidth: 0.789865
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.428 37.9351C30.9126 37.9351 37.7907 31.057 37.7907 22.5724C37.7907 14.0878 30.9126 7.20972 22.428 7.20972C13.9434 7.20972 7.06531 14.0878 7.06531 22.5724C7.06531 31.057 13.9434 37.9351 22.428 37.9351Z",
    fill: "#A5A5A8",
    stroke: "white",
    strokeWidth: 0.677027
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2276_105",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 33,
    height: 33
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.573 37.9351C31.0576 37.9351 37.9357 31.057 37.9357 22.5724C37.9357 14.0878 31.0576 7.20972 22.573 7.20972C14.0884 7.20972 7.21033 14.0878 7.21033 22.5724C7.21033 31.057 14.0884 37.9351 22.573 37.9351Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.677027
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2276_105)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2989 6.53223L21.2666 22.8629H23.2989L22.5005 37.9257L37.3114 35.2742L39.9988 14.5946L33.4713 8.85481L23.2989 6.53223Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20851 20.5281C8.55816 23.3758 10.4107 26.3386 13.2576 25.989C22.9199 24.8026 21.5623 18.5936 21.4321 16.5826C22.1314 22.278 26.457 24.3683 33.7037 23.4785C35.8604 23.2137 36.744 18.9985 36.5052 17.0537C36.2067 14.6228 29.7704 14.2674 21.7473 15.2525C13.7241 16.2376 7.77144 16.9685 8.20851 20.5281Z",
    fill: "#A5A5A8",
    stroke: "#6A6A6D",
    strokeWidth: 1.24122,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6632 32.3442C26.0295 32.0696 28.5548 29.3519 28.3037 26.2742L16.1133 27.2688C16.3644 30.3465 19.2969 32.6189 22.6632 32.3442Z",
    fill: "white",
    stroke: "#424246",
    strokeWidth: 0.564189,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2417 29.0322H27.5804",
    stroke: "#424246",
    strokeWidth: 0.451351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0567 22.1368C23.4438 21.1497 22.4035 18.532 22.21 17.3465C22.21 15.7497 24.0245 15.532 28.4519 15.532C32.8793 15.532 35.5648 15.8949 35.7825 17.0562C36.0003 19.0885 35.2745 22.1368 34.2584 22.6449C33.2422 23.153 29.3229 23.3707 26.0567 22.1368Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.112838
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3713 23.4982C20.4681 22.1163 21.5569 19.4515 20.9037 17.2015C20.5316 15.92 18.4889 16.2343 14.6617 16.8386C11.2504 17.3772 8.63748 18.8708 8.92781 20.1773C9.07289 22.3179 10.7242 24.5786 11.6859 24.9676C12.6476 25.3566 15.7504 25.2256 18.3713 23.4982Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.112838
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5083 10.4514L37.7825 13.895L41.226 15.1692L37.7825 16.4434L36.5083 19.8869L35.2341 16.4434L31.7905 15.1692L35.2341 13.895L36.5083 10.4514Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2276_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/SUN.61dae8cf2cb9c284c8975ecc030f8b80.svg";
export { ForwardRef as ReactComponent };